import { Component, ChangeDetectionStrategy, Input } from '@angular/core';

@Component({
  selector: 'pac-alert',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AlertComponent {
  /**
   * Тип уведомления
   */
  @Input() type: 'positive' | 'negative' | 'warning' | 'info' = 'info';

  /**
   * Главный текст
   */
  @Input() title: string;

  /**
   * Описание
   */
  @Input() description: string;

  /**
   * Показывает иконку
   */
  @Input() iconVisible: boolean = true;

  /**
   * Центрирует иконку по вертикали
   */
  @Input() iconCentered: boolean = false;

}
